"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpButton = void 0;
var icons_1 = require("@qwilr/kaleidoscope/icons");
var icons_2 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var react_1 = __importDefault(require("react"));
var c = (0, BemBuilder_1.default)("help-button");
var HelpButton = function (_a) {
    var onClick = _a.onClick, isOpen = _a.isOpen;
    return (react_1.default.createElement("button", { className: c(), "aria-expanded": isOpen, onClick: onClick },
        react_1.default.createElement("span", { className: c("icon") },
            react_1.default.createElement(icons_2.HelpLite, null),
            react_1.default.createElement(icons_1.Close, { size: icons_1.IconSize.Small })),
        react_1.default.createElement("div", { className: c("label") }, "Help")));
};
exports.HelpButton = HelpButton;
